import axios from 'axios';

import { API } from '@/config/constants';
import { getActiveAuthToken, getActiveSessionRevision, getActiveSessionType, SESSION_TYPE_CLOUD } from './authenticatedClient';


export const lookupAccessCodes = async (orderId, config) => {
  const response = await axios.get(`${API}/access-codes/lookup`, {
    ...config,
    params: { ...config?.params, order_id: orderId },
  });
  return response.data;
};

export const createAccessCode = async (data, config) => {
  const response = await axios.post(`${API}/access-codes`, data, ...config ? [config] : []);
  return response.data;
};

export const updateAccessCode = async (codeId, data, config) => {
  const response = await axios.patch(`${API}/access-codes/${codeId}`, data, ...config ? [config] : []);
  return response.data;
};

// Reporting is an explicit command; never borrow a replacement session's token.
export const reportAccessCode = async (codeId, data, authority) => {
  if (!authority?.token || authority.revision !== getActiveSessionRevision()
      || authority.token !== getActiveAuthToken() || getActiveSessionType() !== SESSION_TYPE_CLOUD) {
    const error = new Error('Reopen this report from your current online session.');
    error.code = 'REPORT_SESSION_CHANGED';
    throw error;
  }
  const response = await axios.post(`${API}/access-codes/${codeId}/report`, data, {
    headers: { Authorization: `Bearer ${authority.token}` },
  });
  return response.data;
};

export const deleteAccessCode = async (codeId, config, requireNoContent = false) => {
  const response = await axios.delete(`${API}/access-codes/${codeId}`, ...config ? [config] : []);
  if (requireNoContent && response.status !== 204) throw new Error('Access-code deletion was not acknowledged with HTTP 204.');
  return response.data;
};
